import React, { useEffect, useState } from 'react';
import api from '../services/api';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useNavigate } from 'react-router-dom';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from 'reactstrap';
import { toast } from 'react-toastify';
import { LiaAngleDoubleUpSolid } from 'react-icons/lia';
import '../styles/floatingForm.css'
import '../styles/createPackage.css';

const UpdatePackageInPage = ({ setShowUpdatePackage, containerUpdateRef, id }) => {
  const [open, setOpen] = useState('');

  // Map fields to their respective accordions for error highlighting
const fieldToAccordionMap = {
  departurePoint: "Departure",
  departureDate: "Departure",
  departureAirline: "Departure",
  arrivalPoint: "Arrival",
  arrivalDate: "Arrival",
  arrivalAirline: "Arrival",
  roomSharing: "room-details",
  highlights: "highlights-details",
  included: "included-details",
  notIncluded: "not-included-details",
  requirement: "requirements-details",
  bookingPolicy: "booking-policy-details",
  cancellationPolicy: "cancellation-policy-details",
};



  // --- Data lists ---
  const [producttype, setProducttype] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [departureCities, setDepartureCities] = useState([]);
  const [airlinesList, setAirlinesList] = useState([]);
  const [packageName, setPackageName] = useState('');
  const [selectedProducttype, setSelectedProducttype] = useState('');
  const [selectedVendor, setSelectedVendor] = useState(JSON.parse(localStorage.getItem("vendor")).id);
  const [price, setPrice] = useState('');
  const [price_discount, setPrice_discount] = useState('');
  const [highlights, setHighlights] = useState('');
  const [included, setIncluded] = useState('');
  const [notIncluded, setNotIncluded] = useState('');
  const [requirement, setRequirement] = useState('');
  const [bookingPolicy, setBookingPolicy] = useState('');
  const [cancellationPolicy, setCancellationPolicy] = useState('');
  const [rawdahotelimages, setrawdahotelimages] = useState(null);
  const [kabahotelimages, setkabahotelimages] = useState(null);
  const [exrawdahotelimages, setexrawdahotelimages] = useState('');
  const [exkabahotelimages, setexkabahotelimages] = useState('');
  const [airline, setAirline] = useState('');
  const [airlineDetails, setAirlineDetails] = useState('');
  const [arrivalDate, setArrivalDate] = useState('');
  const [arrivalDetails, setArrivalDetails] = useState('');
  const [arrivalPoint, setArrivalPoint] = useState('');
  const [daysDetails, setDaysDetails] = useState('');
  const [departureDate, setDepartureDate] = useState('');
  const [lastbookingdate, setlastbookingdate] = useState('');
  const [departureDetails, setDepartureDetails] = useState('');
  const [departurePoint, setDeparturePoint] = useState('');
  const [kabahotelname, setKabahotelname] = useState('');
  const [distanceFromKaba, setDistanceFromKaba] = useState('');
  const [kabawalkdis, setKabawalkdis] = useState('');
  const [kabacar, setKabacar] = useState('');
  const [rawdahotelname, setRawdahotelname] = useState('');
  const [distanceFromRawda, setDistanceFromRawda] = useState('');
  const [rawdawalkdis, setRawdawalkdis] = useState('');
  const [rawdacardis, setRawdacardis] = useState('');
  const [food, setFood] = useState('');
  const [foodDetails, setFoodDetails] = useState('');
  const [kabaDetails, setKabaDetails] = useState('');
  const [numberOfDays, setNumberOfDays] = useState('');
  const [rawdaDetails, setRawdaDetails] = useState('');
  const [roomDetails, setRoomDetails] = useState('');
  const [roomSharing, setRoomSharing] = useState('');
  const [sightseeing, setSightseeing] = useState('');
  const [sightseeingDetails, setSightseeingDetails] = useState('');
  const [transfer, setTransfer] = useState('');
  const [transferDetails, setTransferDetails] = useState('');
  const [visa, setVisa] = useState('');
  const [visaDetails, setVisaDetails] = useState('');
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [departureAirline, setDepartureAirline] = useState('');
  const [arrivalAirline, setArrivalAirline] = useState('');
  const [faqs, setFaqs] = useState([]);
  const [isLastBookingEdited, setIsLastBookingEdited] = useState(false);
  const [groupTransport, setGroupTransport] = useState('');
  const [travelInsurance, setTravelInsurance] = useState('');
  const [laundryService, setLaundryService] = useState('');
  const [simIncluded, setSimIncluded] = useState('');
  const [zamzamIncluded, setZamzamIncluded] = useState('');
  const [kitIncluded, setKitIncluded] = useState('');
  const [tourGuidance, setTourGuidance] = useState('');

useEffect(() => {
  if (departureDate && !isLastBookingEdited) {
    const depDate = new Date(departureDate);

    depDate.setDate(depDate.getDate() - 11);

    const formattedDate = depDate.toISOString().split("T")[0];

    setlastbookingdate(formattedDate);
  }
}, [departureDate, isLastBookingEdited]);


  useEffect(() => {
    const fetchProducttype = async () => {
      const response = await api.get('/page/get-all');
      setProducttype(response.data.data);
    };

    const fetchVendors = async () => {
      const response = await api.get('/vendor/get-all');
      setVendors(response.data.data);
    };

    const fetchDepartureCities = async () => {
      try {
        const response = await api.get('/departurecities/get-all');
        setDepartureCities(Array.isArray(response.data.data) ? response.data.data : []);
      } catch (error) {
        console.error('Error fetching departure cities:', error);
      }
    };

    const fetchAirlines = async () => {
      try {
        const response = await api.get('/airlines/get-all');
        setAirlinesList(Array.isArray(response.data.data) ? response.data.data : []);
      } catch (error) {
        console.error('Error fetching airlines:', error);
      }
    };

const fetchProductFaqs = async (productId) => {
  if (!productId) return;

  try {
    const res = await api.get(`/product/getcardfaqbyid/${productId}`);
    const list = res.data?.data || [];

    setFaqs(
      list.map((f) => ({
        id: f.id,
        question: f.faq_que || "",
        answer: f.faq_ans || "",
      }))
    );
  } catch (err) {
    console.error("FAQ fetch failed", err);
  }
};


const fetchPackageDetails = async () => {
  const response = await api.get(`/product/get/${id}`);
  console.log("Package details response:", response.data);
  const packageData = response.data.data;
      setPackageName(packageData.packagename);
      setSelectedProducttype(packageData.category_id);
      setSelectedVendor(packageData.vendor_id);
      setPrice(packageData.price);
      setPrice_discount(packageData.price_discount);
      setHighlights(packageData.highlights);
      setIncluded(packageData.included);
      setNotIncluded(packageData.not_included);
      setRequirement(packageData.requirement);
      setBookingPolicy(packageData.booking_policy);
      setCancellationPolicy(packageData.cancellation_policy);
      setexkabahotelimages(packageData.kabahotelnameimages);
      setexrawdahotelimages(packageData.rawdahotelnameimages);
      setArrivalDate(packageData.arrival_date);
      setArrivalDetails(packageData.airline_details);
      setArrivalPoint(packageData.arrival_point);
      setDaysDetails(packageData.days_details);
      setArrivalAirline(packageData.arrival_airline);
      setGroupTransport(packageData.group_transport);
      setTravelInsurance(packageData.travel_insurance);
      setLaundryService(packageData.laundry_service);
      setSimIncluded(packageData.sim_included);
      setZamzamIncluded(packageData.zamzam_included);
      setKitIncluded(packageData.kit_included);
      setTourGuidance(packageData.tour_guidance);

      setDepartureDate(packageData.departure_date);
      if (packageData.lastbookingdate) {
        const formatted = new Date(packageData.lastbookingdate)
          .toISOString()
          .split("T")[0];

        setlastbookingdate(formatted);
        setIsLastBookingEdited(true);
      } else {
        setIsLastBookingEdited(false); 
      }
      setDepartureDetails(packageData.departure_details);
      setDeparturePoint(packageData.departure_point);
      setDepartureAirline(packageData.departure_airline);
      setKabahotelname(packageData.kabahotelname);
      setKabahotelname(packageData.kabahotelname);
      setDistanceFromKaba(packageData.distance_from_kaba);
      setKabawalkdis(packageData.kabawalkdis);
      setKabacar(packageData.kabacar);
      setRawdahotelname(packageData.rawdahotelname);
      setDistanceFromRawda(packageData.distance_from_rawda);
      setRawdawalkdis(packageData.rawdawalkdis);
      setRawdacardis(packageData.rawdacardis);
      setFood(packageData.food);
      setFoodDetails(packageData.food_details);
      setKabaDetails(packageData.kaba_details);
      setNumberOfDays(packageData.number_of_days);
      setRawdaDetails(packageData.rawda_details);
      setRoomDetails(packageData.room_details);
      setRoomSharing(packageData.room_sharing);
      setSightseeing(packageData.sightseeing);
      setSightseeingDetails(packageData.sightseeing_details);
      setTransfer(packageData.transfer);
      setTransferDetails(packageData.transfer_details);
      setVisa(packageData.visa);
      setVisaDetails(packageData.visa_details);

    };

    fetchProducttype();
    fetchVendors();
    fetchDepartureCities();
    fetchPackageDetails();
    fetchAirlines();
    fetchProductFaqs(id);
  }, [id]);

  const validateImageDimensions = (file, maxWidth, maxHeight) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => {
        if (image.width <= maxWidth && image.height <= maxHeight) {
          resolve(true);
        } else {
          resolve(false);
        }
      };
      image.onerror = () => {
        reject(new Error('Invalid image file.'))
      };
      image.src = URL.createObjectURL(file);
    });
  };

  const addFaq = () => {
  setFaqs((p) => [...p, { question: "", answer: "" }]);
};

const removeFaq = (index) => {
  setFaqs((p) => p.filter((_, i) => i !== index));
};

const updateFaq = (index, field, value) => {
  setFaqs((p) =>
    p.map((f, i) => (i === index ? { ...f, [field]: value } : f))
  );
};

const getImagePreview = (file, existing) => {
  // 1️⃣ User selected new file → local preview
  if (file) {
    return URL.createObjectURL(file);
  }

  // 2️⃣ Existing image from backend
  if (existing) {
    // If backend already sends full URL
    if (existing.startsWith("http")) {
      return existing;
    }

    // Backend sends relative path
    return `${api.defaults.baseURL}${existing.startsWith("/") ? "" : "/"}${existing}`;
  }

  // 3️⃣ Nothing to preview
  return null;
};




  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = {};

    // if (!packageName) errors.packageName = "Package Name cannot be empty";

    const value = (packageName || "").trim();

        if (!value) {
          errors.packageName = "Package Name cannot be empty";
        } else {
          // Allowed: letters, numbers, space, underscore
          const notAllowed = value.match(/[^a-zA-Z0-9 _]/g);

          if (notAllowed) {
            const uniqueChars = [...new Set(notAllowed)];
            errors.packageName = `Package Name cannot contain special characters: ${uniqueChars.join(" ")}`;
          }
        }
    if (!selectedVendor) errors.selectedVendor = "Select a Service Provider";
    if (!selectedProducttype) errors.selectedProducttype = "Select a Pilgrimage Type";
    //if (!city.trim()) errors.city = "City cannot be empty";
    if (!price.trim()) errors.price = "Price cannot be empty";
    if (!roomSharing) errors.roomSharing = "Select room sharing";
    if (!departurePoint) errors.departurePoint = "Select departure city";
    if (!departureDate) errors.departureDate = "Departure date cannot be empty";
    if (!lastbookingdate) errors.lastbookingdate = "last booking date cannot be empty";
    else if (departureDate && lastbookingdate > departureDate) {
                errors.lastbookingdate = "Must be before departure date";
              }
    if (!arrivalPoint) errors.arrivalPoint = "Arrival point is required";
    if (!arrivalDate) errors.arrivalDate = "Arrival date is required";

const allowedImageTypes = ["image/png", "image/jpeg"];

// Kaba Hotel Image
 if (kabahotelimages && !allowedImageTypes.includes(kabahotelimages.type)) {
  errors.kabahotelimages = "Only PNG and JPG allowed";
}

// Rawda Hotel Image
 if (rawdahotelimages && !allowedImageTypes.includes(rawdahotelimages.type)) {
  errors.rawdahotelimages = "Only PNG and JPG allowed";
}



  if (Object.keys(errors).length > 0) {
    setErrors(errors);

    const accordionIds = [
      ...new Set(
        Object.keys(errors)
          .map((field) => fieldToAccordionMap[field])
          .filter(Boolean)
      ),
    ];

    if (accordionIds.length > 0) {
      setOpen(accordionIds[0]); 
    }

    toast.error("All required fields must be filled correctly!");
    return;
  }


    setErrors({});

    const formData = new FormData();
    formData.append('packagename', packageName);
    formData.append('price', price);
    formData.append('price_discount', price_discount);
    formData.append('highlights', highlights);
    formData.append('included', included);
    formData.append('not_included', notIncluded);
    formData.append('requirement', requirement);
    formData.append('booking_policy', bookingPolicy);
    formData.append('cancellation_policy', cancellationPolicy);
    formData.append('category_id', selectedProducttype);
    formData.append('vendor_id', selectedVendor);
    //formData.append('airline', airline);

    formData.append('airline_details', airlineDetails);
    formData.append('arrival_date', arrivalDate);
    formData.append('arrival_details', arrivalDetails);
    formData.append('arrival_point', arrivalPoint);

    formData.append('days_details', daysDetails);
    formData.append('departure_airline', departureAirline);
    formData.append('arrival_airline', arrivalAirline);
    formData.append('departure_date', departureDate);
    formData.append('lastbookingdate', lastbookingdate);
    formData.append('departure_details', departureDetails);
    formData.append('departure_point', departurePoint);

    formData.append('distance_from_kaba', distanceFromKaba);
    formData.append('kabahotelname', kabahotelname);
    formData.append('kabawalkdis', kabawalkdis);
    formData.append('kabacar', kabacar);


    formData.append('rawdahotelname', rawdahotelname);
    formData.append('distance_from_rawda', distanceFromRawda);
    formData.append('rawdawalkdis', rawdawalkdis);
    formData.append('rawdacardis', rawdacardis);

    formData.append('food', food);
    formData.append('food_details', foodDetails);
    formData.append('kaba_details', kabaDetails);
    formData.append('number_of_days', numberOfDays);
    formData.append('rawda_details', rawdaDetails);
    formData.append('room_details', roomDetails);
    formData.append('room_sharing', roomSharing);
    formData.append('sightseeing', sightseeing);
    formData.append('sightseeing_details', sightseeingDetails);
    formData.append('transfer', transfer);
    formData.append('transfer_details', transferDetails);
    formData.append('visa', visa);
    formData.append('visa_details', visaDetails);


    formData.append('group_transport', groupTransport);
    formData.append('laundry_service', laundryService);
    formData.append('sim_included', simIncluded);
    formData.append('zamzam_included', zamzamIncluded);
    formData.append('kit_included', kitIncluded);
    formData.append('tour_guidance', tourGuidance); 
    formData.append("travel_insurance", travelInsurance);


// Kaba Hotel Image
if (kabahotelimages) {
  formData.append('kabahotelnameimages', kabahotelimages);
} else if (exkabahotelimages) {
  formData.append('kabahotelnameimages', exkabahotelimages);
}

// Rawda Hotel Image
if (rawdahotelimages) {
  formData.append('rawdahotelnameimages', rawdahotelimages);
} else if (exrawdahotelimages) {
  formData.append('rawdahotelnameimages', exrawdahotelimages);
}


    faqs
  .filter((f) => f.question.trim() && f.answer.trim())
  .forEach((f) => {
    formData.append("cardfaqq[]", f.question);
    formData.append("cardfaqans[]", f.answer);
  });


    try {
      // Just before api.post
      for (let [key, value] of formData.entries()) {
        if (value instanceof File) {
          console.log(`${key}: FILE -> ${value.name} (${value.type}, ${value.size} bytes)`);
        } else {
          console.log(`${key}: ${value}`);
        }
      }
      const response = await api.post(`/product/update/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
       

      if (response.data.status === 'success') {
        toast.success('Package updated successfully!');
        handleCancel();
      } else {
        toast.error('Failed to update package');
      }
    } catch (error) {
      console.error('Error updating package:', error);
      toast.error('Error updating package');
    }
  };

  const handleCancel = () => {
    // navigate('/manage-package');

    setShowUpdatePackage(false);
  };

  const toggle = (id) => {
    if (open === id) {
      setOpen("0");
    } else {
      setOpen(id);
    }
  };

  return (
    <div className='floating-form-container' ref={containerUpdateRef} >
      <div className="heading">
        <h2>Update Package Details</h2>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="form-container">

          <div className="section-1">

            <div className="input-container-floating-form wid-50">
              <label>Pilgrimage Type *</label>
              <select className={`form-control ${errors.selectedProducttype ? 'is-invalid' : ''}`} value={selectedProducttype} onChange={(e) => setSelectedProducttype(e.target.value)}  >
                <option value="">Pilgrimage Type</option>
                {producttype.map((product) => (
                  <option key={product.id} value={product.id}>
                    {product.name}
                  </option>
                ))}
              </select>
              <b>{errors.selectedProducttype && <span className='text-danger small'>{errors.selectedProducttype}</span>}</b>
            </div>

            <div className="input-container-floating-form wid-50">
              <label htmlFor='vendor'>Package Name *</label>
              <input type="text" className={`form-control ${errors.packageName ? 'is-invalid' : ''}`} value={packageName} onChange={(e) => setPackageName(e.target.value)} placeholder="Enter Package Name" />
              <b>{errors.packageName && <span className='text-danger small'>{errors.packageName}</span>}</b>
            </div>


            <div className="input-container-floating-form wid-50">
              <label htmlFor="yearInBusiness">Price *</label>
              <input type="number" className={`form-control ${errors.price ? 'is-invalid' : ''}`} value={price} onChange={(e) => setPrice(e.target.value)} placeholder="Enter Price" />
              <b>{errors.price && <span className='text-danger small'>{errors.price}</span>}</b>
            </div>

            <div className=' input-container-floating-form wid-50'>
              <label>Discount  Price(only in %)*</label>
              <input type="number" className={`form-control ${errors.price_discount ? 'is-invalid' : ''}`} value={price_discount} onChange={(e) => setPrice_discount(e.target.value)} placeholder="Enter Discount (%)" />
              <b>{errors.price_discount && <span className='text-danger small'>{errors.price_discount}</span>}</b>
            </div>

 




          </div>

          <hr className='form-rule' />

          {/* Section-2 Departure (Full Width) */}
          <div className="w-100">
            <Accordion open={open} toggle={toggle}>
              <AccordionItem>
                <AccordionHeader 
                  targetId="Departure"
                   className={(errors.departurePoint || errors.departureDate) ? "accordion-error" : ""}>Departure Details</AccordionHeader>
                <AccordionBody accordionId="Departure">

                  {/* Row: Departure Point + Date + Airline */}
                  <div className="row g-3">
                    {/* Departure Point */}
                    <div className="col-md-4">
                      <div className="input-container-floating-form">
                        <label>Departure Point *</label>
                        <select
                          className={`form-control ${errors.departurePoint ? "is-invalid" : ""}`}
                          value={departurePoint}
                          onChange={(e) => setDeparturePoint(e.target.value)}
                        >
                          <option value="">Select Departure City</option>
                          {departureCities.map((city) => (
                            <option key={city.id} value={city.id}>
                              {city.dcityname}
                            </option>
                          ))}
                        </select>
                        {errors.departurePoint && (
                          <span className="text-danger small">{errors.departurePoint}</span>
                        )}
                      </div>
                    </div>

                    {/* Departure Date */}
                    <div className="col-md-4">
                      <div className="input-container-floating-form">
                        <label>Departure Date *</label>
                        <input
                          type="date"
                          value={departureDate}
                          onChange={(e) => setDepartureDate(e.target.value)}
                        />
                        {errors.departureDate && (
                          <span className="text-danger small">{errors.departureDate}</span>
                        )}
                      </div>
                    </div>

                    {/*Departure Airline */}
                    <div className="col-md-4">
                      <div className="input-container-floating-form">
                        <label>Departure Airline *</label>
                        <select
                          className="form-control"
                          value={departureAirline}
                          onChange={(e) => setDepartureAirline(e.target.value)}
                        >
                          <option value="">Select Airline</option>
                          {airlinesList.map((a) => (
                            <option key={a.id} value={a.id}>
                              {a.airline_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>

            {/* last booing date */}
            <div className='mt-3 input-container-floating-form wid-50'>
                        <label>last date of Booking *</label>
                        <input
                          type="date"
                          value={lastbookingdate}
                          max={departureDate}
                          onChange={(e) =>{ setlastbookingdate(e.target.value);setIsLastBookingEdited(true);}}
                        />
                        {errors.lastbookingdate && (
                          <span className="text-danger small">{errors.lastbookingdate}</span>
                        )}
            </div>


                  {/* Departure Details (Quill) */}
                  <div className="input-container-floating-form wid-100 mt-3">
                    <label>Departure Description *</label>
                    <ReactQuill
                      theme="snow"
                      value={departureDetails}
                      onChange={setDepartureDetails}
                    />
                  </div>

                </AccordionBody>
              </AccordionItem>
            </Accordion>
          </div>


          {/* Section-3  Arrival Details */}
          <div className="w-100 mt-3">
            <Accordion open={open} toggle={toggle}>
              <AccordionItem>
                <AccordionHeader 
                  targetId="Arrival"
                  className={(errors.arrivalPoint || errors.arrivalDate) ? "accordion-error" : ""}
                >Arrival Details</AccordionHeader>
                <AccordionBody accordionId="Arrival">

                  {/* Row: Departure Point + Date + Airline */}
                  <div className="row g-3">
                    {/* Arrival Point */}
                    <div className="col-md-4">
                      <div className="input-container-floating-form">
                        <label>Arrival Point *</label>
                        <select
                          className={`form-control ${errors.arrivalPoint ? "is-invalid" : ""}`}
                          value={arrivalPoint}
                          onChange={(e) => setArrivalPoint(e.target.value)}
                        >
                          <option value="">Select Arrival City *</option>
                          {departureCities.map((city) => (
                            <option key={city.id} value={city.id}>
                              {city.dcityname}
                            </option>
                          ))}
                        </select>
                        {errors.arrivalPoint && (
                          <span className="text-danger small">{errors.arrivalPoint}</span>
                        )}

                      </div>
                    </div>

                    {/* Arrival Date */}
                    <div className="col-md-4">
                      <div className="input-container-floating-form">
                        <label>Arrival Date *</label>
                        <input
                          type="date"
                          className={`form-control ${errors.arrivalDate ? "is-invalid" : ""}`}
                          value={arrivalDate}
                          onChange={(e) => setArrivalDate(e.target.value)}
                        />
                        {errors.arrivalDate && <span className="text-danger small">{errors.arrivalDate}</span>}

                      </div>
                    </div>

                    {/* Arrival Airline */}
                    <div className="col-md-4">
                      <div className="input-container-floating-form">
                        <label>Arrival Airline *</label>
                        <select
                          className="form-control"
                          value={arrivalAirline}
                          onChange={(e) => setArrivalAirline(e.target.value)}
                        >
                          <option value="">Select Airline *</option>
                          {airlinesList.map((a) => (
                            <option key={a.id} value={a.id}>
                              {a.airline_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  {/* Arrival Details (Quill) */}
                  <div className="input-container-floating-form wid-100 mt-3">
                    <label>Arrival Description</label>
                    <ReactQuill
                      theme="snow"
                      value={arrivalDetails}
                      onChange={setArrivalDetails}
                    />
                  </div>

                </AccordionBody>
              </AccordionItem>
            </Accordion>
          </div>

          {/* Section-4 - Visa */}
          <div className="w-100 mt-3">
            <Accordion open={open} toggle={toggle}>
              <AccordionItem>
                <AccordionHeader targetId="visa-details">Visa Details</AccordionHeader>
                <AccordionBody accordionId="visa-details">

                  {/* Visa Input (Single line) */}
                  <div className="row g-3 mb-3">
                    <div className="col-md-6">
                      <div className="input-container-floating-form">
                        <label>Visa *</label>
                        <input
                          type="text"
                          className="form-control"
                          value={visa}
                          onChange={(e) => setVisa(e.target.value)}
                          placeholder="Enter Visa"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Visa Description (Full width with Quill) */}
                  <div className="input-container-floating-form w-100">
                    <label>Visa Description</label>
                    <ReactQuill
                      theme="snow"
                      value={visaDetails}
                      onChange={setVisaDetails}
                    />
                  </div>
                </AccordionBody>
              </AccordionItem>
            </Accordion>
          </div>

          {/* Section-5 Room */}
          <div className="w-100 mt-3">
            <Accordion open={open} toggle={toggle}>
              <AccordionItem>
                <AccordionHeader targetId="room-details"
                  className={errors.roomSharing ? "accordion-error" : ""}
                >Room Details</AccordionHeader>
                <AccordionBody accordionId="room-details">

                  {/* Room Sharing (dropdown) */}
                  <div className="row g-3 mb-3">
                    <div className="col-md-6">
                      <div className="input-container-floating-form">
                        <label htmlFor="roomSharing">Room Sharing</label>
                        <select
                          className={`form-control ${errors.roomSharing ? "is-invalid" : ""}`}
                          value={roomSharing}
                          onChange={(e) => setRoomSharing(e.target.value)}
                        >
                          <option value="">Select room sharing</option>
                          <option value="single">Single</option>
                          <option value="double">Double</option>
                          <option value="triple">Triple</option>
                          <option value="quad">Quad</option>
                          <option value="five">Five</option>
                          <option value="six">Six</option>
                        </select>
                        {errors.roomSharing && (
                          <span className="text-danger small">{errors.roomSharing}</span>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Room Description (full width) */}
                  <div className="input-container-floating-form w-100">
                    <label>Room Description</label>
                    <ReactQuill
                      theme="snow"
                      value={roomDetails}
                      onChange={setRoomDetails}
                    />
                  </div>
                </AccordionBody>
              </AccordionItem>
            </Accordion>
          </div>

          {/* Section - Kaba */}
          <div className="w-100 mt-3">
            <Accordion open={open} toggle={toggle}>
              <AccordionItem>
                <AccordionHeader targetId="kaba-details">Kaba Hotel Details</AccordionHeader>
                <AccordionBody accordionId="kaba-details">

                  {/* Distance From Kaba */}
                  <div className="row g-3 mb-3">
                    <div className="col-md-3">
                      <div className="input-container-floating-form">
                        <label>Kaba Hotel Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={kabahotelname}
                          onChange={(e) => setKabahotelname(e.target.value)}
                          placeholder="Enter Hotel Name"
                        />
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="input-container-floating-form">
                        <label>Distance  (In Km)</label>
                        <input
                          type="text"
                          className="form-control"
                          value={distanceFromKaba}
                          onChange={(e) => setDistanceFromKaba(e.target.value)}
                          placeholder="Enter distance"
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="input-container-floating-form">
                        <label>Walk Distance (In Km)</label>
                        <input
                          type="text"
                          className="form-control"
                          value={kabawalkdis}
                          onChange={(e) => setKabawalkdis(e.target.value)}
                          placeholder="Enter Walk Distance"
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="input-container-floating-form">
                        <label>Car Distance  (In Km)</label>
                        <input
                          type="text"
                          className="form-control"
                          value={kabacar}
                          onChange={(e) => setKabacar(e.target.value)}
                          placeholder="Enter Car Distance"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-container-floating-form">
                        <label>
                          Hotel Image <br /> (only png and jpg)
                        </label>

                        <div className="file-select">
                          <div className="file-select-button">Choose File</div>
                          <div className="file-select-name">
                            {kabahotelimages?.name || 
                            (exkabahotelimages ? "Using existing image" : "No file chosen")}
                          </div>

                          <input
                            type="file"
                            accept="image/*"
                            onChange={(e) => setkabahotelimages(e.target.files[0])}
                          />
                        </div>

                        {errors.kabahotelimages && (
                          <b>
                            <span className="text-danger small">
                              {errors.kabahotelimages}
                            </span>
                          </b>
                        )}

                        {/* 🔹 Preview */}
                        {getImagePreview(kabahotelimages, exkabahotelimages) && (
                          <img
                            src={getImagePreview(kabahotelimages, exkabahotelimages)}
                            
                            alt="Kaba Hotel"
                            style={{
                              width: "100%",
                              height: "150px",
                              objectFit: "contain",
                              marginTop: "8px",
                              borderRadius: "6px",
                              border: "1px solid #ddd"
                            }}
                          />
                        )}
                      </div>
                    </div>



                  </div>

                  {/* Kaba Details (Full Width with Quill) */}
                  <div className="input-container-floating-form w-100">
                    <label>Kaba Description</label>
                    <ReactQuill
                      theme="snow"
                      value={kabaDetails}
                      onChange={setKabaDetails}
                    />
                  </div>

                </AccordionBody>
              </AccordionItem>
            </Accordion>
          </div>

          {/* Section - Rawda */}
          <div className="w-100 mt-3">
            <Accordion open={open} toggle={toggle}>
              <AccordionItem>
                <AccordionHeader targetId="rawda-details">Rawda Hotel Details</AccordionHeader>
                <AccordionBody accordionId="rawda-details">

                  {/* Distance From Rawda */}
                  <div className="row g-3 mb-3">
                    <div className="col-md-3">
                      <div className="input-container-floating-form">
                        <label>Rawda Hotel Name </label>
                        <input
                          type="text"
                          className="form-control"
                          value={rawdahotelname}
                          onChange={(e) => setRawdahotelname(e.target.value)}
                          placeholder="Enter Rawda Hotel Name"
                        />
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="input-container-floating-form">
                        <label>Distance  (In Km)</label>
                        <input
                          type="text"
                          className="form-control"
                          value={distanceFromRawda}
                          onChange={(e) => setDistanceFromRawda(e.target.value)}
                          placeholder="Enter distance"
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="input-container-floating-form">
                        <label>Walk Distance (In Km)</label>
                        <input
                          type="text"
                          className="form-control"
                          value={rawdawalkdis}
                          onChange={(e) => setRawdawalkdis(e.target.value)}
                          placeholder="Enter Walk Distance"
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="input-container-floating-form">
                        <label>Car Distance  (In Km)</label>
                        <input
                          type="text"
                          className="form-control"
                          value={rawdacardis}
                          onChange={(e) => setRawdacardis(e.target.value)}
                          placeholder="Enter Car Distance"
                        />
                      </div>
                    </div>

                  <div className="col-md-6">
                    <div className="input-container-floating-form">
                      <label>
                        Hotel Image <br /> (only png and jpg)
                      </label>

                      <div className="file-select">
                        <div className="file-select-button">Choose File</div>
                        <div className="file-select-name">
                          {rawdahotelimages?.name || 
                          (exrawdahotelimages ? "Using existing image" : "No file chosen")}
                        </div>

                        <input
                          type="file"
                          accept="image/*"
                          onChange={(e) => setrawdahotelimages(e.target.files[0])}
                        />
                      </div>

                      {errors.rawdahotelimages && (
                        <b>
                          <span className="text-danger small">
                            {errors.rawdahotelimages}
                          </span>
                        </b>
                      )}

                      {/* 🔹 Preview */}
                      {getImagePreview(rawdahotelimages, exrawdahotelimages) && (
                        <img
                          src={getImagePreview(rawdahotelimages, exrawdahotelimages)}
                          alt="Rawda Hotel"
                          style={{
                            width: "100%",
                            height: "150px",
                            objectFit: "contain",
                            marginTop: "8px",
                            borderRadius: "6px",
                            border: "1px solid #ddd"
                          }}
                        />
                      )}
                    </div>
                  </div>

                  </div>

                  {/* Rawda Details (Full Width with Quill) */}
                  <div className="input-container-floating-form w-100">
                    <label>Rawda Description</label>
                    <ReactQuill
                      theme="snow"
                      value={rawdaDetails}
                      onChange={setRawdaDetails}
                    />
                  </div>

                </AccordionBody>
              </AccordionItem>
            </Accordion>
          </div>

          {/* Section - Sightseeing */}
          <div className="w-100 mt-3">
            <Accordion open={open} toggle={toggle}>
              <AccordionItem>
                <AccordionHeader targetId="sightseeing-details">Sightseeing Details</AccordionHeader>
                <AccordionBody accordionId="sightseeing-details">

                  {/* Sightseeing Input */}
                  <div className="row g-3 mb-3">
                    <div className="col-md-6">
                      <div className="input-container-floating-form">
                        <label>Sightseeing </label>
                        <input
                          type="text"
                          className="form-control"
                          value={sightseeing}
                          onChange={(e) => setSightseeing(e.target.value)}
                          placeholder="Enter sightseeing"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Sightseeing Description (Full Width with Quill) */}
                  <div className="input-container-floating-form w-100">
                    <label>Sightseeing Description</label>
                    <ReactQuill
                      theme="snow"
                      value={sightseeingDetails}
                      onChange={setSightseeingDetails}
                    />
                  </div>

                </AccordionBody>
              </AccordionItem>
            </Accordion>
          </div>

          {/* Section - Food */}
          <div className="w-100 mt-3">
            <Accordion open={open} toggle={toggle}>
              <AccordionItem>
                <AccordionHeader targetId="food-details">Food Details</AccordionHeader>
                <AccordionBody accordionId="food-details">

                  {/* Food Input */}
                  <div className="row g-3 mb-3">
                    <div className="col-md-6">
                      <div className="input-container-floating-form">
                        <label>Food</label>
                        <input
                          type="text"
                          className="form-control"
                          value={food}
                          onChange={(e) => setFood(e.target.value)}
                          placeholder="Enter food"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Food Details (Full Width with Quill) */}
                  <div className="input-container-floating-form w-100">
                    <label>Food Description</label>
                    <ReactQuill
                      theme="snow"
                      value={foodDetails}
                      onChange={setFoodDetails}
                    />
                  </div>

                </AccordionBody>
              </AccordionItem>
            </Accordion>
          </div>

          {/* Section - Transfer */}
          <div className="w-100 mt-3">
            <Accordion open={open} toggle={toggle}>
              <AccordionItem>
                <AccordionHeader targetId="transfer-details">Transfer Details</AccordionHeader>
                <AccordionBody accordionId="transfer-details">

                  {/* Transfer Input */}
                  <div className="row g-3 mb-3">
                    <div className="col-md-6">
                      <div className="input-container-floating-form">
                        <label>Transfer</label>
                        <input
                          type="text"
                          className="form-control"
                          value={transfer}
                          onChange={(e) => setTransfer(e.target.value)}
                          placeholder="Enter transfer info"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Transfer Details (Full Width with Quill) */}
                  <div className="input-container-floating-form w-100">
                    <label>Transfer Description</label>
                    <ReactQuill
                      theme="snow"
                      value={transferDetails}
                      onChange={setTransferDetails}
                    />
                  </div>

                </AccordionBody>
              </AccordionItem>
            </Accordion>
          </div>

          {/* Section - Highlights */}
          <div className="w-100 mt-3">
            <Accordion open={open} toggle={toggle}>
              <AccordionItem>
                <AccordionHeader targetId="highlights-details">Highlights Details</AccordionHeader>
                <AccordionBody accordionId="highlights-details">

                  {/* Highlights (Full Width with Quill) */}
                  <div className="input-container-floating-form w-100">
                    <label>Highlights</label>
                    <ReactQuill
                      theme="snow"
                      value={highlights}
                      onChange={setHighlights}
                    />
                  </div>

                </AccordionBody>
              </AccordionItem>
            </Accordion>
          </div>

          {/* Section - Included */}
          <div className="w-100 mt-3">
            <Accordion open={open} toggle={toggle}>
              <AccordionItem>
                <AccordionHeader targetId="included-details">Included Details</AccordionHeader>
                <AccordionBody accordionId="included-details">
                  <div className="input-container-floating-form w-100">
                    <ReactQuill theme="snow" value={included} onChange={setIncluded} />
                  </div>
                </AccordionBody>
              </AccordionItem>
            </Accordion>
          </div>

          {/* Section - Not Included */}
          <div className="w-100 mt-3">
            <Accordion open={open} toggle={toggle}>
              <AccordionItem>
                <AccordionHeader targetId="not-included-details">Not Included Details</AccordionHeader>
                <AccordionBody accordionId="not-included-details">
                  <div className="input-container-floating-form w-100">
                    <ReactQuill theme="snow" value={notIncluded} onChange={setNotIncluded} />
                  </div>
                </AccordionBody>
              </AccordionItem>
            </Accordion>
          </div>

          {/* Section - Requirements */}
          <div className="w-100 mt-3">
            <Accordion open={open} toggle={toggle}>
              <AccordionItem>
                <AccordionHeader targetId="requirements-details">Requirements Details</AccordionHeader>
                <AccordionBody accordionId="requirements-details">
                  <div className="input-container-floating-form w-100">
                    <ReactQuill theme="snow" value={requirement} onChange={setRequirement} />
                  </div>
                </AccordionBody>
              </AccordionItem>
            </Accordion>
          </div>

          {/* Section - Booking Policy */}
          <div className="w-100 mt-3">
            <Accordion open={open} toggle={toggle}>
              <AccordionItem>
                <AccordionHeader targetId="booking-policy-details">Booking Policy Details</AccordionHeader>
                <AccordionBody accordionId="booking-policy-details">
                  <div className="input-container-floating-form w-100">
                    <ReactQuill theme="snow" value={bookingPolicy} onChange={setBookingPolicy} />
                  </div>
                </AccordionBody>
              </AccordionItem>
            </Accordion>
          </div>

          {/* Section - Cancellation Policy */}
          <div className="w-100 mt-3">
            <Accordion open={open} toggle={toggle}>
              <AccordionItem>
                <AccordionHeader targetId="cancellation-policy-details">Cancellation Policy Details</AccordionHeader>
                <AccordionBody accordionId="cancellation-policy-details">
                  <div className="input-container-floating-form w-100">
                    <ReactQuill theme="snow" value={cancellationPolicy} onChange={setCancellationPolicy} />
                  </div>
                </AccordionBody>
              </AccordionItem>
            </Accordion>
          </div>

          {/* Section - Additional Services */}
          <div className="w-100 mt-3">
            <Accordion open={open} toggle={toggle}>
              <AccordionItem>
                <AccordionHeader targetId="additional-services">
                  Additional Services
                </AccordionHeader>

                <AccordionBody accordionId="additional-services">

                  <div className="row g-3 mb-3">

                  {/* Transfer Input */}
                    <div className="col-md-4">
                      <div className="input-container-floating-form">
                        <label>Transfer</label>
                        <input
                          type="text"
                          className="form-control"
                          value={transfer}
                          onChange={(e) => setTransfer(e.target.value)}
                          placeholder="Enter transfer info"
                        />
                      </div>
                    </div>

                    <div className="col-md-4 input-container-floating-form">
                      <label>Group Transport</label>
                      <input
                        type="text"
                        className="form-control"
                        value={groupTransport}
                        onChange={(e) => setGroupTransport(e.target.value)}
                        placeholder="Enter Group Transport"
                      />
                    </div>

                    <div className="col-md-4 input-container-floating-form">
                      <label>Travel Insurance</label>
                      <input
                        type="text"
                        className="form-control"
                        value={travelInsurance}
                        onChange={(e) => setTravelInsurance(e.target.value)}
                        placeholder="Enter Travel Insurance Details"
                      />
                    </div>

                    <div className="col-md-4 input-container-floating-form">
                      <label>Laundry Service</label>
                      <input
                        type="text"
                        className="form-control"
                        value={laundryService}
                        onChange={(e) => setLaundryService(e.target.value)}
                        placeholder="Enter Laundry Service"
                      />
                    </div>

                    <div className="col-md-4 input-container-floating-form">
                      <label>SIM Included</label>
                      <input
                        type="text"
                        className="form-control"
                        value={simIncluded}
                        onChange={(e) => setSimIncluded(e.target.value)}
                        placeholder="Enter SIM Included"
                      />
                    </div>

                    <div className="col-md-4 input-container-floating-form">
                      <label>Zamzam Included</label>
                      <input
                        type="text"
                        className="form-control"
                        value={zamzamIncluded}
                        onChange={(e) => setZamzamIncluded(e.target.value)}
                        placeholder="Enter Zamzam Included"
                      />
                    </div>

                    <div className="col-md-4 input-container-floating-form">
                      <label>Kit Included</label>
                      <input
                        type="text"
                        className="form-control"
                        value={kitIncluded}
                        onChange={(e) => setKitIncluded(e.target.value)}
                        placeholder="Enter Kit Included"
                      />
                    </div>

                    <div className="col-md-4 input-container-floating-form">
                      <label>Tour Guidance</label>
                      <input
                        type="text"
                        className="form-control"
                        value={tourGuidance}
                        onChange={(e) => setTourGuidance(e.target.value)}
                        placeholder="Enter Tour Guidance"
                      />
                    </div>

                  </div>

                </AccordionBody>
              </AccordionItem>
            </Accordion>
          </div>

          {/* Section - Images */}
          <div className="w-100 mt-3">
            

                        {/* ================= FAQ SECTION ================= */}
            <div className="w-100 mt-3">
              <Accordion open={open} toggle={toggle}>
                <AccordionItem>
                  <AccordionHeader targetId="faq-details">
                    FAQ Details
                  </AccordionHeader>

                  <AccordionBody accordionId="faq-details">
                    {faqs.map((faq, index) => (
                      <div key={index} className="mb-3">
                        <div className="input-container-floating-form">
                          <label>Question</label>
                          <input
                            type="text"
                            className="form-control"
                            value={faq.question}
                            onChange={(e) =>
                              updateFaq(index, "question", e.target.value)
                            }
                            placeholder="Enter question"
                          />
                        </div>

                        <div className="input-container-floating-form mt-2">
                          <label>Answer</label>
                          <textarea
                            className="form-control"
                            rows="2"
                            value={faq.answer}
                            onChange={(e) =>
                              updateFaq(index, "answer", e.target.value)
                            }
                            placeholder="Enter answer"
                          />
                        </div>

                        <button
                          type="button"
                          className="btn btn-sm btn-danger mt-2"
                          onClick={() => removeFaq(index)}
                        >
                          Remove
                        </button>
                      </div>
                    ))}
                    <hr class="form-rule"></hr>
                    <button
                      type="button"
                    className="btn"
                    style={{ marginTop: "8px" ,backgroundColor: " #BC6C25",color: "#fff",fontWeight: 700  }}
                      onClick={addFaq}
                    >
                      + Add FAQ
                    </button>
                  </AccordionBody>
                </AccordionItem>
              </Accordion>
            </div>

          </div>

          <div className="form-btn-container">

            <button type='submit'>Update</button>
            <button type='reset' onClick={handleCancel}>Cancel</button>

          </div>
        </div>

      </form>

    </div>
  );
};

export default UpdatePackageInPage;
